import React, { Component } from "react";
import firebaseManager from "../../../../model/Firebase/FirebaseManager";
import { Redirect } from "react-router-dom";

class Login extends Component {
  constructor(props) {
    super(props);
    this.login = this.login.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.state = {
      email: "",
      password: "",
      redirectToHome: false,
    };
  }

  login(e) {
    e.preventDefault();
    firebaseManager.loginUserTechnician(
      this.state.email,
      this.state.password,
      this.loginCallbackSuccess,
      this.loginCallbackFail
    );
  }

  loginCallbackSuccess = () => {
    this.setState({
      redirectToHome: true,
    });
  };

  loginCallbackFail(errMessage) {
    document.getElementById("alertLoginTec").classList.remove("d-none");
    document.getElementById("alertLoginTec").innerHTML = errMessage;
  }

  handleChange(e) {
    this.setState({
      [e.target.name]: e.target.value,
    });
  }
  render() {
    return (
      <React.Fragment>
        {this.state.redirectToHome ? (
          <Redirect push to="/homeTechnician" />
        ) : null}
        <div className="text-center mt-5">
          <form className="mx-auto">
            <div className="form-group">
              <input
                type="email"
                name="email"
                id="email"
                onChange={this.handleChange}
                value={this.state.email}
                className="size"
                aria-describedby="emailHelp"
                placeholder="Email"
                required
              />
            </div>
            <div className="form-group">
              <input
                type="password"
                id="password"
                name="password"
                onChange={this.handleChange}
                value={this.state.password}
                className="size"
                placeholder="Password"
                required
              />
            </div>
            <button onClick={this.login} className="btn btn-secondary">
              Log In
            </button>
          </form>
        </div>
      </React.Fragment>
    );
  }
}
export default Login;
